(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .decorator('ngRepeatDirective', ngRepeatDirectiveDecorator);

    var
        rValueIdentifier = /^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))/;

    ngRepeatDirectiveDecorator.$inject = ['$delegate'];
    function ngRepeatDirectiveDecorator($delegate) {
        var ngRepeatCompile = $delegate[0].compile;
        $delegate[0].compile = ngRepeatCompileProxy;
        return $delegate;
        
        function ngRepeatCompileProxy($element, $attr) {
            var ngRepeatLink, valueIdentifier, match;
            match = rValueIdentifier.exec($attr.ngRepeat) || [];
            valueIdentifier = match[3] || match[1];
            ngRepeatLink = ngRepeatCompile.apply(this, arguments);
            return ngRepeatLinkProxy;

            function ngRepeatLinkProxy($scope, $element, $attr, ctrl, $transclude) {
                return ngRepeatLink($scope, $element, $attr, ctrl, transcludeProxy);

                function transcludeProxy(ngRepeatTransclude) {
                    return $transclude(ngRepeatTranscludeProxy);

                    function ngRepeatTranscludeProxy(clone, scope) {
                        defineValueProperty(clone, scope);
                        return ngRepeatTransclude.apply(this, arguments);
                    }
                }
            }

            function defineValueProperty(clone, scope) {
                var value;
                Object.defineProperty(scope, valueIdentifier, { get: getValue, set: setValue });

                function getValue() { return value; }
                function setValue(val) {
                    value = val;
                    if (angular.isObject(value))
                        value.$$clone = clone;
                }
            }
        }
    }
})();